"use client";

import React from "react";
import { Coins, Wrench, ShieldCheck, House, Feather, Palette } from "lucide-react";
import { Card, CardHeader, CardTitle, CardContent, CardDescription } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const features = [{
  id: 1,
  number: "01",
  iconName: "Wrench",
  title: "Specjalistyczny sprzęt",
  description: "Wykorzystujemy zaawansowane pompy płuczące i chemię czyszczącą, która jest bezpieczna dla Twojej instalacji, a jednocześnie bezlitosna dla osadów."
}, {
  id: 2,
  number: "02",
  iconName: "Feather",
  title: "Szybka realizacja",
  description: "Nasz proces płukania jest zoptymalizowany tak, aby przywrócić sprawność ogrzewania w kilka godzin, bez zbędnego bałaganu w Twoim domu."
}, {
  id: 3,
  number: "03",
  iconName: "Coins",
  title: "Niższe rachunki",
  description: "Usunięcie zaledwie 1mm kamienia kotłowego może obniżyć zużycie paliwa o 10%. Z nami realnie oszczędzasz na kosztach eksploatacji."
}, {
  id: 4,
  number: "04",
  iconName: "House",
  title: "Dojazd do klienta",
  description: "Działamy na terenie Śląska i Małopolski, docierając bezpośrednio do domów jednorodzinnych z pełnym zapleczem technicznym."
}, {
  id: 5,
  number: "05",
  iconName: "ShieldCheck",
  title: "Bezpieczeństwo systemu",
  description: "Regularne odmulanie zapobiega awariom pomp i zaworów, przedłużając żywotność całego systemu grzewczego o wiele lat."
}, {
  id: 6,
  number: "06",
  iconName: "Palette",
  title: "Czystość i standard",
  description: "Pracujemy w standardzie 'czystego montażu'. Po zakończeniu płukania Twoja kotłownia pozostaje w nienagannym stanie."
}];
const iconMap: Record<string, React.ElementType> = {
  Coins,
  Wrench,
  ShieldCheck,
  House,
  Feather,
  Palette
};
export default function ZaletyBlachyT18() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="94941" id="dlaczego-warto-nam-zaufać" className="bg-background text-foreground py-24 lg:py-32 overflow-hidden">
      <div ref={ref} className={`max-w-7xl mx-auto px-6 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
        <div className="text-center max-w-3xl mx-auto mb-16 md:mb-24">
          <span className="text-primary text-sm font-extrabold tracking-widest uppercase mb-4 block font-mono">
            Dlaczego Hydroflush?
          </span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-extrabold mb-6 text-secondary tracking-tight font-sans">
            Czysta instalacja – niższe rachunki za ogrzewanie
          </h2>
          <p className="text-lg text-muted-foreground leading-relaxed font-medium">
            Profesjonalne płukanie instalacji CO to inwestycja, która zwraca się błyskawicziale. Usuwamy zanieczyszczenia, przywracając Twojemu domowi ciepło i efektywność.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
          {features.map((feature, i) => {
          const IconComponent = iconMap[feature.iconName];
          return <div key={feature.id} data-index={i} className="h-full">
                <Card className="relative h-full overflow-hidden border-border/50 bg-card hover:border-primary/50 hover:-translate-y-2.5 hover:shadow-2xl hover:shadow-primary/5 transition-all duration-500 group rounded-3xl">
                  {}
                  <div className="absolute -top-6 -right-4 text-[120px] font-black text-primary/5 select-none pointer-events-none z-0 transition-transform duration-700 group-hover:scale-110 group-hover:text-primary/10">
                    {feature.number}
                  </div>
                  
                  <CardHeader className="relative z-10 flex flex-col items-center pt-10 pb-4 px-8">
                    <div className="w-16 h-16 rounded-full bg-primary/10 backdrop-blur-sm flex items-center justify-center text-primary mb-6 shadow-sm group-hover:scale-110 group-hover:bg-primary group-hover:text-primary-foreground transition-all duration-500">
                      {IconComponent && <IconComponent className="w-8 h-8" strokeWidth={1.5} />}
                    </div>
                    <CardTitle className="text-xl text-center text-secondary font-extrabold leading-tight font-sans">
                      {feature.title}
                    </CardTitle>
                  </CardHeader>
                  
                  <CardContent className="relative z-10 pb-10 px-8">
                    <CardDescription className="text-center text-base text-muted-foreground leading-relaxed font-medium">
                      {feature.description}
                    </CardDescription>
                  </CardContent>
                </Card>
              </div>;
        })}
        </div>
      </div>
    </section>;
}